module.exports = __webpack_public_path__ + "static/media/waterFilterDefault.2b017b26.png";